// Collects every scrollable ancestor so their scroll offsets can be restored after a reflow.
const getScrollableAncestors = (element) => {
  const scrollables = [];
  let node = element?.parentElement;
  while (node) {
    const { overflowY } = window.getComputedStyle(node);
    const isScrollable = overflowY === "auto" || overflowY === "scroll";
    if (isScrollable && node.scrollHeight > node.clientHeight) {
      scrollables.push(node);
    }
    node = node.parentElement;
  }
  return scrollables;
};

// Auto-sizing a textarea shrinks it to minHeight before measuring scrollHeight; that momentary
// shrink lets the browser clamp any scrolled ancestor toward the top. Capture and restore the
// offsets so typing near the bottom of a tall field does not scroll the page.
export const resizeTextareaPreservingScroll = ({ textarea, minHeight }) => {
  if (!textarea) return;
  const scrollables = getScrollableAncestors(textarea);
  const offsets = scrollables.map((node) => node.scrollTop);
  const windowScrollX = window.scrollX;
  const windowScrollY = window.scrollY;
  textarea.style.height = minHeight;
  textarea.style.height = `${textarea.scrollHeight}px`;
  scrollables.forEach((node, index) => {
    node.scrollTop = offsets[index];
  });
  if (window.scrollX !== windowScrollX || window.scrollY !== windowScrollY) {
    window.scrollTo(windowScrollX, windowScrollY);
  }
};
